import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store';
import {
  GET_USER_LIST,
  GET_REGISTER_USER_FORM_VISIBILITY,
  GET_SELECTED_USER,
  GET_CURRENT_USER_TAB,
  GET_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  GET_CLIENT_CONTRACTS,
  GET_USER_BONDS,
  GET_SELECTED_BOND,
  GET_LOCALE_TYPES, GET_ROLE_CLASSIFICATIONS,
} from './types';

export const getters: GetterTree<State, RootState> = {
    [GET_USER_LIST](state: State) {
        return state.users;
    },
    [GET_REGISTER_USER_FORM_VISIBILITY](state: State) {
        return state.showRegisterForm;
    },
    [GET_SELECTED_USER](state: State) {
        return state.userSelected;
    },
    [GET_CURRENT_USER_TAB](state: State) {
        return state.currentTab;
    },
    [GET_USER_PROFILE_FUNCTIONALITIES_GROUPED](state: State) {
        return state.groupedProfileFunctionalities;
    },
    [GET_CLIENT_CONTRACTS](state: State) {
        return state.clientContracts;
    },
    [GET_USER_BONDS](state: State) {
        return state.userBonds;
    },
    [GET_SELECTED_BOND](state: State) {
        return state.bondSelected;
    },
    [GET_LOCALE_TYPES](state: State) {
        return state.localeTypes;
    },
    [GET_ROLE_CLASSIFICATIONS](state: State) {
      return state.roleClassifications;
    },
};
